import { render, staticRenderFns } from "./Char.vue?vue&type=template&id=6fbc8124&scoped=true&"
import script from "./Char.vue?vue&type=script&lang=js&"
export * from "./Char.vue?vue&type=script&lang=js&"
import style0 from "./Char.vue?vue&type=style&index=0&id=6fbc8124&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbc8124",
  null
  
)

export default component.exports